export default function getApiErrorMessage(error, fallbackMessage = null) {
  const payload = error?.response?.data;
  const raw = payload?.messages ?? payload?.message;

  if (Array.isArray(raw) && raw.length > 0) {
    return raw[0];
  }

  if (typeof raw === "string" && raw.trim()) {
    return raw;
  }

  return fallbackMessage;
}
